import { Outlet } from 'react-router';
import type { RouteObject } from 'react-router';

import { RequireAnonymousUser } from '@jane/business-admin/components/auth/RequireAnonymousUser';
import { load } from '@jane/shared/util';

const Login = load(() => import('../features/Login'));
const SsoCallback = load(() => import('../features/SsoCallback'));
const RequestPasswordReset = load(
  () => import('../features/RequestPasswordReset')
);
const ResetPassword = load(() => import('../features/ResetPassword'));
const ManagerRegistration = load(
  () => import('../features/ManagerRegistration')
);

export const authRoutes = (): RouteObject[] => [
  {
    element: (
      <RequireAnonymousUser>
        <Outlet />
      </RequireAnonymousUser>
    ),
    children: [
      {
        path: '/register',
        element: <ManagerRegistration />,
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/sso/callback',
        element: <SsoCallback />,
      },
      {
        path: '/forgot-your-password',
        element: <RequestPasswordReset />,
      },
      {
        path: '/reset-password/:token',
        element: <ResetPassword />,
      },
    ],
  },
];
